import React from "react";

function Features() {
  return (
    <div className="h-full pb-10 bg-[#27272e] block">
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/circle-1.png"
        alt=""
        className="absolute mt-24 right-0 z-0"
      />
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/line-3.png"
        alt=""
        className="absolute  left-0 mt-[1000px] z-0"
      />
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-5.png"
        alt=""
        className="absolute left-16 mt-[800px] z-0 "
      />
      <div className="z-10">
        <div className="flex pt-32 items-center">
          <h1 className=" text-6xl w-2/3 ml-32 text-white font-bold font-dmsans leading-[60px]">
            We have Impressive Features
          </h1>
          <p className=" text-lg z-10 mx-12 w-1/3 mr-56 text-gray-400">
            You will love all of the features in our Template. 100% guaranteed
            satisfaction.
          </p>
        </div>
        <div className="mt-32">
          <div className="flex gap-10 justify-center items-center ">
            <div className="h-400 w-400 rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/react.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Powered by React
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                Our Template is Perfect for all devices. It is made by React
                Structure. React JS was designed to provide high performance in
                mind.
              </p>
            </div>
            <div className="h-400 w-400  rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/code-2.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Reusable Components
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                All the Components of this template are reusable. We made
                abstrak using functional components. You can reuse any
                components
              </p>
            </div>
            <div className="h-400 w-400 z-10 rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/sass.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Sass Available
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                Sass is more stable, powerful, and elegant because it is an
                extension of CSS. So, it is easy for designers and developers to
                work more efficiently and quickly.
              </p>
            </div>
          </div>
          <div className="flex gap-10 justify-center items-center ">
            <div className="h-400 w-400 z-10 rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/loading.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Fast Loading Speed
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                The website speed is very important. Hence we’ve created Abstrak
                in a way that your website will load fast, and you will get
                better performance.
              </p>
            </div>
            <div className="h-400 w-400  rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/responsive.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Fully Responsive Layout
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                All the pages of this template are responsive. We used the
                Bootstrap framework to build the website. It’s the best in
                class.
              </p>
            </div>
            <div className="h-400 w-400  rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-13.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Modern Design
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                Abstrak is a modern creative design for Creative, Digital,
                Corporate agencies, etc. Abstrak is a perfect solution for your
                digital agency
              </p>
            </div>
          </div>
          <div className="flex  gap-10 justify-center items-center ">
            <div className="h-400 w-400 z-10 rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/code.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Well Organised Codes
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                The coding structure of our items is organized so other
                developers can easily recognize the pattern and make updates as
                needed.
              </p>
            </div>
            <div className="h-400 w-400  rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-20.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Lifetime Update
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                Purchase our template only once and get lifetime updates. We
                keep updating our products to stay up to date with the latest
                trends and technology.
              </p>
            </div>
            <div className="h-400 w-400  rounded-3xl hover:bg-gradient-180 from-[#27272e] to-[#303035]  ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-21.png"
                alt=""
                className=" ml-14 mt-14"
              />
              <h2 className="text-white ml-14 mt-5 text-2xl w-2/4 font-dmsans">
                Mobile Optimized
              </h2>
              <p className="text-gray-500 ml-14 mt-5 w-3/4 font-dmsans font-semibold">
                All the pages of this template are optimized. We used the
                Bootstrap framework to build the website. It’s the best in
                class.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
